export async function callAPI (func, responseMessage, setShowSignifier, setResponseMessage, setShowError, setProcessing) {
    setProcessing(true);
    await func.then((res) => {
      setShowSignifier(true);
      if (res) {
        setResponseMessage(responseMessage);
        setShowError(false);
      } else {
        setShowError(true);
      }
      setProcessing(false);
    });
};